<template>
  <div v-if="!isSend" class="text-center painel">
    <background-wrapper>
      <div>
        <h1>Ooops :(</h1>
        <h2 class="feedback-error--text mb-2">
          <span v-if="expiredPassword"> Sua senha, por segurança, expirou! </span>
          <span v-else> O link de acesso, por segurança, expirou! </span>
        </h2>
        <p class="mb-8">
          Insira seu usuário abaixo para enviarmos <br />
          um novo link.
        </p>
        <cs-message v-if="responseErrors" v-model="responseErrors" />
        <v-form>
          <cs-text-field
            class="login"
            v-model="login"
            label="Usuário"
            :error-messages="loginErrors"
            @change="validateField"
            @keydown="resetResponseErrors"
            required
          />
          <cs-recaptcha
            ref="vue_recaptcha"
            class="no-margin"
            v-model="recaptcha"
            :sitekey="global.recaptchaKey"
          />
          <request
            id="solicitar_link"
            method="post"
            class="w-100 mt-6"
            :style="{ color: !formIsInvalid ? '#fff' : '#888888 !important' }"
            :headers="headers"
            :url="url ? url : global.sendEmailFirstLogin"
            :value="payload"
            :disabled="formIsInvalid"
            :loading="loading"
            @resolved="resolved"
          >
            Solicitar novo link
          </request>
        </v-form>
      </div>
    </background-wrapper>
  </div>
  <div v-else class="text-center painel">
    <h1>Pronto! :)</h1>
    <h2 class="feedback-success--text mb-2">Solicitação enviada com sucesso!</h2>
    <p>
      Verifique sua caixa de email e caso não tenha <br />
      recebido, <a @click="handleGoBack">clique aqui</a>
    </p>
  </div>
</template>

<script>
import BackgroundWrapper from '@/components/background/BackgroundWrapper.vue'
import loginService from '@/services/loginService'
import csTextField from '@/components/campos/csTextField.vue'
import csMessage from '@/components/campos/csMessage.vue'
import csRecaptcha from '@/components/campos/csRecaptcha.vue'
import Request from '@/components/Request.vue'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapState } from 'vuex'

export default {
  mixins: [loginService, validationMixin],
  validations() {
    return {
      login: { required }
    }
  },

  components: { BackgroundWrapper, csTextField, csMessage, csRecaptcha, Request },
  props: {
    token: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    expiredPassword: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      login: '',
      recaptcha: '',
      isSend: false,
      responseErrors: [],
      loading: false
    }
  },
  computed: {
    ...mapState(['global']),
    loginErrors() {
      const errors = []
      if (!this.$v.login.$dirty) return errors
      !this.$v.login.required && errors.push('Esse campo é obrigatório.')
      return errors
    },
    formIsInvalid() {
      return !(this.login && this.recaptcha && this.loginErrors.length === 0)
    },
    headers() {
      const contentHeader = { 'Content-Type': 'application/json' }
      if (this.requestToken) {
        contentHeader.RequestVerificationToken = this.requestToken
      }
      return contentHeader
    },
    payload() {
      const token = this.$route.query.token
      return {
        login: this.login,
        recaptcha: this.recaptcha,
        token: token
      }
    }
  },
  methods: {
    validateField() {
      this.$v.login.$touch()
    },
    resolved(response) {
      this.resetResponseErrors()
      if (response.status === 200) {
        this.isSend = true
        return
      }
      this.responseErrors.push(response.data.errors[''][0])
      // Se não tiver sucesso para enviar o acesso temos que reiniciar o captcha
      this.$refs.vue_recaptcha.reset()
      this.recaptcha = ''
    },
    resetResponseErrors() {
      this.responseErrors = []
    },
    handleGoBack() {
      this.$router.go(this.$route.currentRoute)
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  ::v-deep .v-input {
    margin-bottom: 1rem;
  }
}
</style>
